<template>
  <LazyPdpPopupCampaignModal
    v-model="showPopUpModal"
    :show-loading="toCheckoutIsClicked"
    @on-click-go-to-checkout="goToCheckout()"
  />

  <StickyFooterContainer>
    <div
      class="max-w-screen-xl w-full flex items-start lg:items-center place-content-between px-0"
    >
      <div class="flex items-start lg:items-center">
        <StickyFooterPriceDisplay
          :strike-through-price-exists-and-differs="
            !!store.currentAccessoryPrice?.RegularDownPayment &&
            store.currentAccessoryPrice?.RegularDownPayment !==
              store.currentAccessoryPrice?.DownPayment
          "
          :current-total-regular-monthly-price-to-display="
            store.currentAccessoryPrice?.RegularDownPayment
              ? `${store.currentAccessoryPrice?.RegularDownPayment}`
              : '0'
          "
          :current-total-monthly-price-to-display="'0'"
          in-x-months-text=""
          :current-total-direct-price-to-display="
            store.currentAccessoryPrice?.DownPayment.toLocaleString('sv-SE') ||
            ''
          "
          :current-full-price-string-for-screen-reader="
            priceStringForScreenReader
          "
          :is-binding-period-active="true"
          :is-monthly-payment="false"
          :show-only-direct-price="true"
          :extra-text-line="
            store.currentAccessoryLowestPartialPayment &&
            store.currentAccessoryLowestPartialPayment.DownPayment > 22
              ? `Delbetala din produkt från ${store.currentAccessoryLowestPartialPayment.DownPayment} kr/mån med Klarna`
              : ''
          "
        />
      </div>
      <AppButton
        :show-loading="toCheckoutIsClicked"
        :disabled="toCheckoutIsClicked"
        class="min-w-136"
        @on-click="goToCheckout(true)"
      >
        Till kassan
      </AppButton>
    </div>
  </StickyFooterContainer>
</template>

<script lang="ts" setup>
const notifications = useNotificationStore();
const store = useMyProductPageStore();
const { $api } = useNuxtApp();
const { pushAddToCartEvent } = useGoogleAnalyticsEvents();

const showPopUpModal = ref(false);

const toCheckoutIsClicked: Ref<boolean> = ref(false);

const AddDiscount = async () => {
  try {
    await $api.ShoppingCartModule.AddDiscountsToCart(
      store.productState.addedPopupDiscounts,
    );
  } catch (error) {
    notifications.setStandardErrorNotification();
  }
};

const priceStringForScreenReader = computed(() => {
  let priceString = '';

  const strikeThroughPrice =
    !!store.currentAccessoryPrice?.RegularDownPayment &&
    store.currentAccessoryPrice?.RegularDownPayment !==
      store.currentAccessoryPrice?.DownPayment
      ? store.currentAccessoryPrice.RegularDownPayment
      : 0;

  if (strikeThroughPrice) {
    priceString += `Tidigare ${strikeThroughPrice} kronor, nu `;
  }

  priceString +=
    store.currentAccessoryPrice?.DownPayment.toLocaleString('sv-SE') +
    ' kronor.';

  return priceString;
});

const goToCheckout = async (showPopupIsApplicable?: boolean) => {
  if (store.currentVariant?.DisableBuyButton || !store.currentAccessoryPrice) {
    notifications.setNewNotification({
      type: 'error',
      title: 'Slutsåld',
      msg: 'Denna produktvarianten är inte tillgänglig just nu.',
      isCloseable: true,
      link: {
        url: 'https://www.halebop.se/support',
        text: 'Kontakta supporten',
      },
    });

    return;
  }

  if (showPopupIsApplicable && !!store.popupDiscounts?.length) {
    showPopUpModal.value = true;
    return;
  }

  toCheckoutIsClicked.value = true;

  const selectedVariantId =
    store.currentVariant?.ProductAttributeCombinationId ?? 0;

  try {
    await $api.ShoppingCartModule.AddPacToCart(selectedVariantId);

    if (store.productState.addedPopupDiscounts.length > 0) {
      await AddDiscount();
    }

    pushAddToCartEvent(store.trackingData);
    navigateTo('/shop/varukorg', { external: true });
  } catch (e) {
    notifications.setStandardErrorNotification();
  } finally {
    toCheckoutIsClicked.value = false;
  }
};
</script>

<style lang="scss" scoped></style>
